import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useConfig } from 'wagmi'

import { useSandbox } from '@/domain/sandbox/useSandbox'
import { vpnCheckQueryOptions } from '@/features/compliance/logic/vpnCheckQueryOptions'
import { ongoingCampaignsQueryOptions } from '@/features/spark-rewards/data/ongoingCampaignsQueryOptions'

export function usePrefetchCampaigns(): void {
  const { isInSandbox } = useSandbox()
  const queryClient = useQueryClient()
  const wagmiConfig = useConfig()

  useEffect(() => {
    void queryClient.prefetchQuery(ongoingCampaignsQueryOptions({ wagmiConfig, isInSandbox }))
    void queryClient.prefetchQuery(vpnCheckQueryOptions())
  }, [isInSandbox, wagmiConfig, queryClient])
}
